import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/router";
import { Date } from "core-js";
import Vue from "vue";
import { baseurl } from "../../helpers/helper";

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,
  state: {
    cart: {},
    companyOrders: [],
    customerOrders: [],
  },

  mutations: {
    SAVE_ORDERS(state, data) {
      state.companyOrders = data;
    },
    ...vuexfireMutations,
  },

  getters: {},

  actions: {
    addNewOrder(
      { commit },
      {
        orderList,
        menuId,
        menu,
        companyId,
        total,
        type,
        username,
        menu_slug,
        details,
      }
    ) {
      db.collection("orders")
        .doc(companyId)
        .collection("userOrders")
        .add({
          order: orderList,
          ownerId: auth.currentUser.uid,
          total,
          menuId,
          menu,
          type,
          details,
          createdAt: new Date(),
          status: 1,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully placed order",
            variant: "success",
          };

          commit("ADD_TO_TOAST", data, { root: true });
          commit("Cart/CLEAR_CART", {}, { root: true });
          router.push({
            name: "customerView",
            params: { username, menu_slug },
          });
        });
    },
    companyFirstOrders: firestoreAction(
      ({ commit, dispatch, state, bindFirestoreRef }, { limit }) => {
        return bindFirestoreRef(
          "companyOrders",
          db
            .collection("orders")
            .doc(auth.currentUser.uid)
            .collection("userOrders")
            .orderBy("createdAt", "desc")
            .limit(limit)
        );
      }
    ),

    companyPaginateOrders: firestoreAction(
      ({ commit, dispatch, state, bindFirestoreRef }, { limit, lastItem }) => {
        return bindFirestoreRef(
          "companyOrders",
          db
            .collection("orders")
            .doc(auth.currentUser.uid)
            .collection("userOrders")
            .orderBy("createdAt", "desc")
            .startAfter(lastItem)
            .limit(limit)
        );
      }
    ),

    customerOrders: firestoreAction(
      (
        { commit, dispatch, rootState, bindFirestoreRef },
        { limit, companyId }
      ) => {
        return bindFirestoreRef(
          "customerOrders",
          db
            .collection("orders")
            .doc(companyId)
            .collection("userOrders")
            .where("ownerId", "==", auth.currentUser.uid)
            .orderBy("createdAt", "desc")
            .limit(limit)
        );
      }
    ),

    changeOrderStatus({ commit }, { orderId, status }) {
      db.collection("orders")
        .doc(auth.currentUser.uid)
        .collection("userOrders")
        .doc(orderId)
        .update({ status })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated order status",
            variant: "success",
          };

          commit("ADD_TO_TOAST", data, { root: true });
        });
    },
  },
};
